<template>
    <div class="vrm-modal vrm-modal--wide mfp-with-anim">
        <div class="vrm-modal__header">
            <div class="vrm-modal__title">
                {{ $t('users.add_team', { i18nFallback: 'Add team' }) }}
            </div>
        </div>
        <form class="vrm-modal__content" @submit.prevent="onSubmit" @reset.prevent="onReset">
            <div class="vrm-form__fieldset-item">
                <label class="sg-textfield-label">
                    <span class="sg-textfield-label-caption">
                        {{ $t('teams.team', { i18nFallback: 'Team' }) }}:
                    </span>
                </label>
                <vrm-dropdown
                    :options="teams"
                    :value="team"
                    search-enabled
                    @input="item => (team = item)"
                />
            </div>
            <div class="vrm-form__fieldset-item">
                <label class="sg-textfield-label">
                    <span class="sg-textfield-label-caption">
                        {{ $t('users.role', { i18nFallback: 'Role' }) }}:
                    </span>
                </label>
                <vrm-dropdown
                    v-model="accessLevelOption"
                    :options="userAccessLevelOptions"
                    :disabled="userAccessLevelOptions.length < 2 || busy"
                />
            </div>
            <fieldset class="vrm-fieldset">
                <span v-if="hasAnyTeams">
                    {{
                        $t('groups.create_new_team_hint', {
                            i18nFallback: 'Do you want to create a new team?',
                        })
                    }}
                </span>
                <span v-else>
                    {{
                        $t('groups.create_first_team_hint', {
                            i18nFallback: 'You seem to have no teams yet, create one to link it:',
                        })
                    }}
                </span>
                <router-link :to="{ name: 'base.user-groups' }">
                    {{ $t('groups.goto_teams_page', { i18nFallback: 'Go to the teams page' }) }}
                </router-link>
            </fieldset>
            <br />
            <div class="sg-spread">
                <button type="reset" class="sg-btn sg-site" :disabled="busy">
                    {{ $t('common.cancel', { i18nFallback: 'Cancel' }) }}
                </button>
                <button type="submit" class="sg-btn sg-blue" :disabled="busy || !team">
                    {{ $t('users.add_team', { i18nFallback: 'Add team' }) }}
                </button>
            </div>
        </form>
        <modal-close-handle />
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ngInject } from '@/vue/decorators/angular-interop';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import VrmToggle from '@/vue/components/shared/toggles/VrmToggle';
import VrmDropdown from '@/vue/components/shared/VrmDropdown';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: { VrmDropdown, VrmToggle, ModalCloseHandle },
})
@AngularLocaleBundle('common')
@AngularLocaleBundle('groups')
@AngularLocaleBundle('users')
export default class InstallationLinkUserGroupsModal extends Vue {
    @Prop()
    idSite;
    @Prop()
    userAccessLevelOptions;

    /** @type UserGroupsService */
    @ngInject()
    UserGroupsService;
    @ngInject()
    ApiService;
    @ngInject()
    InstallationsService;

    busy = false;
    alreadyLinked = new Set();
    team = '';
    accessLevel = 0;

    get accessLevelOption() {
        return this.userAccessLevelOptions.find(option => option.accessLevel === this.accessLevel);
    }

    set accessLevelOption(option) {
        this.accessLevel = option.accessLevel;
    }

    get hasAnyTeams() {
        return this.$store.state.UserGroupsService.visible.length > 0;
    }

    get teams() {
        return this.$store.state.UserGroupsService.visible.filter(
            g => !this.alreadyLinked.has(g.idUserGroup),
        );
    }

    @Watch('idSite', { immediate: true })
    async onSiteChanged() {
        const id = this.idSite;
        if (!id) return;
        const { data } = await this.ApiService.call2(`/installations/${this.idSite}/users`);
        if (id !== this.idSite) return;
        this.alreadyLinked = new Set(data.userGroups.map(group => group.idUserGroup));
    }

    created() {
        this.UserGroupsService.loadVisible();
    }

    async onSubmit() {
        this.busy = true;
        try {
            await this.UserGroupsService.linkUserGroupsToSiteAsSiteAdmin(this.idSite, [
                {
                    idUserGroup: this.team.idUserGroup,
                    accessLevel: this.accessLevel,
                },
            ]);
            this.$emit('close');
        } finally {
            this.busy = false;
        }
    }

    async onReset() {
        this.$emit('close');
    }
}
</script>
